import template from './template.html';
import './styles.css';

controller.$inject = [];

export function controller() {
    const vm = this;
}

export default () => ({
    template: template,
    controller: controller,
    restrict: 'E',
    controllerAs: 'vm',
    bindToController: {},
    scope: {}
});



// WEBPACK FOOTER //
// ./src/js/components/common/loadingindicator/index.js